import SliderNew from './slider-new'

export default SliderNew
